<template>
    <div class="up-box">
        <el-upload
                class="avatar-uploader"
                :class="{disabled:disabled}"
                :action="fileUpUrl"
                :data="QiniuData"
                :list-type="type === 6?'picture-card':''"
                :multiple="limit?true:false"
                :show-file-list="true"
                :file-list="fileList"
                :accept="type === 6?'image/*' : ''"
                :on-error="uploadError"
                :on-success="uploadSuccess"
                :before-upload="beforeAvatarUpload"
                :on-preview="handlePreview"
                :before-remove="beforeRemove" :disabled="disabled">
            <div v-if="type === 6 && !disabled">
                <i class="el-icon-plus"></i>
            </div>
            <div v-if="type === 7 && !disabled">
                <el-button class="blue-btn" type="primary">点击上传</el-button>
            </div>
        </el-upload>
    </div>
</template>

<script>
    import {genUpToken} from "@/utils/CryptoJS";
    import {filePath, fileUpUrl} from "@/config";

    export default {
        name: "InfoUpFile",
        data() {
            return {
                loading: false,
                QiniuData: {
                    fname: '', //  文件名
                    key: '', //文件名字处理
                    token: genUpToken() //七牛云token
                },
                fileUpUrl: fileUpUrl,
                fileList: []
            }
        },
        props: {
            limit: {
                type: Number
            },
            type: {
                type: Number
            },
            index: {
                type: Number
            },
            file: {
                type: Array
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        created() {

        },
        methods: {
            //  上传钱判断
            beforeAvatarUpload(file) {
                this.QiniuData.fname = file.name;
                this.QiniuData.key = `${new Date().getTime()}${file.name}`
                this.uping = this.$loading({
                    lock: true,
                    text: "上传中，请稍后",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.2)",
                });
            },
            //  删除上传文件
            beforeRemove(file, fileList) {
                this.fileList = fileList
                this.$emit('saveFile', [this.index, this.fileList])
            },
            //上传文件预览
            handlePreview(file) {
                window.open(file.url)
            },
            //  上传成功
            uploadSuccess(res, file) {
                this.uping.close();
                if (this.limit) {
                    this.fileList.push(
                        {
                            name: file.name,
                            url: `${filePath}/${res.key}`
                        }
                    )
                } else {
                    this.fileList = [{
                        name: file.name,
                        url: `${filePath}/${res.key}`
                    }]
                }
                this.$emit('saveFile', [this.index, this.fileList])

            },
            //  上传失败
            uploadError() {
                this.uping.close();
                this.$message({
                    message: "上传出错，请重试！",
                    type: "error",
                    center: true,
                });
            },
        },
        watch: {
            file() {
                this.fileList = this.file
            }
        }
    }
</script>

<style scoped lang="scss">
    .up-box {
        .up-image {
            width: 197px;
            height: 197px;
        }

        .up-image-up {
            width: 197px;
            height: 197px;
            position: relative;
            border: 1px solid #eeeeee;

            &:before {
                position: absolute;
                content: '+';
                font-size: 26px;
                color: #333333;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
</style>